<template>
  <div>
    <label v-if="label" class="form-label" :for="id">{{ label }}:</label>
    <multi-select :id="id" v-bind="$attrs" ref="input" class="h-10" :show-labels="false" :class="{ error: error }" :label="labelField" v-on="$listeners">
      <template v-for="(_, slot) in $slots">
        <template :slot="slot">
          <slot :name="slot" />
        </template>
      </template>
    </multi-select>
    <div v-if="error" class="form-error">{{ error }}</div>
  </div>
</template>

<script>

import MultiSelect from 'vue-multiselect'
export default {
  components: {
    MultiSelect,
  },
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default() {
        return `select-input-${this._uid}`
      },
    },
    label: String,
    labelField: String,
    error: String,
  },
  data() {
    return {
      selected: this.value,
    }
  },

  methods: {
    focus() {
      this.$refs.input.focus()
    },
    select() {
      this.$refs.input.select()
    },
  },
}
</script>
<style>
  .form-select2 .vs__search::placeholder,
  .form-select2 .vs__dropdown-toggle,
  .form-select2 .vs__dropdown-menu {
    background: white;
    border: none;
    color: #394066;
  }

  .form-select2 {
      padding: 4px !important;
  }

  .multiselect--disabled {
      opacity: 1;

  }

  .multiselect--disabled  .multiselect__tags {
      background: rgba(248, 250, 252, var(--tw-bg-opacity));
  }
  .multiselect--disabled  .multiselect__single {
      background: rgba(248, 250, 252, var(--tw-bg-opacity));
  }

  .multiselect--disabled .multiselect__current, .multiselect--disabled .multiselect__select {
      background: transparent;
      height: 42px;
  }

  .multiselect__tags{
      height: 42px;
  }

  .form-select2 .vs__dropdown-toggle{
      height: 42px;
  }

  .form-select2 .vs__clear,
  .form-select2 .vs__open-indicator {
    fill: #394066;
  }
</style>

